import { styled } from '@mui/material'
import BasicDatagrid from '../../../components/shared/tables/BasicDatagrid'

const StyledDatagridAcervo = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '64.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '64.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '65vh'
  },
  '& .MuiDataGrid-cell': {
    /* overflow: hidden; */
    padding: '0.3rem 0.1rem!important',
    justifyContent: 'inital',
    /* white-space: nowrap; */
    fontSize: '0.8rem',

    // background: 'chocolate',
    /* height: -webkit-fill-available; */
    maxHeight: '54px!important',

    /* min-height: -webkit-fill-available!important; */
    whiteSpace: 'nowrap!important',
    textAlign: 'left',

    '&:nth-of-type(6)': {
      textAlign: 'center!important'
    },
    '&:nth-of-type(5)': {
      textAlign: 'center!important'
    }
  },
  '& .MuiDataGrid-row': {
    /* overflow: hidden; */

    maxHeight: '54px!important'
  },
  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    width: '100%',
    '&:nth-of-type(6)': {
      backgroundColor: 'red'
    }
  }
}))

export default StyledDatagridAcervo
